import { DynamicModuleFeature } from 'features/Modules';

export const SharedContentModuleFeature: React.FC<Content.SharedContentModule> = ({ content }) => {
	const { modules } = content?.properties?.content?.properties ?? {};
	return (
		<>{modules && modules.map((module, index) => <DynamicModuleFeature contentModule={module} key={index} />)}</>
	);
};
